module.exports = __webpack_public_path__ + "img/Straight-through-Process(1).f98ac557.png";